(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer-casa"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('CasaCartDrawer');
  var overlay = document.getElementById('CasaCartOverlay');
  if(!root || !overlay) return;
  var SECTION_ID = root.getAttribute('data-section-id');
  var lastFocus;

  // Verrou du scroll de la page : body.overflow seul ne suffit pas (html a overflow-x:clip,
  // donc il n'est pas propagé au viewport) ni sur iOS -> on fige le body à sa position.
  var lockedY = null;
  function lockPage(){ if(lockedY !== null) return; lockedY = window.scrollY; var s = document.body.style;
    s.overflow='hidden'; s.position='fixed'; s.top=(-lockedY)+'px'; s.left='0'; s.right='0'; s.width='100%'; }
  function unlockPage(){ if(lockedY === null) return; var s = document.body.style;
    s.overflow=s.position=s.top=s.left=s.right=s.width='';
    window.scrollTo({ top: lockedY, behavior: 'instant' }); lockedY = null; }

  function open(){ lastFocus = document.activeElement; root.classList.add('is-open'); overlay.classList.add('is-open');
    root.setAttribute('aria-hidden','false'); lockPage();
    document.addEventListener('keydown', onKey); refresh();
    setTimeout(function(){ var b=root.querySelector('[data-cart-close]'); if(b) b.focus({ preventScroll: true }); }, 50); }
  function close(){ root.classList.remove('is-open'); overlay.classList.remove('is-open');
    root.setAttribute('aria-hidden','true'); unlockPage();
    document.removeEventListener('keydown', onKey); if(lastFocus) lastFocus.focus({ preventScroll: true }); }
  function onKey(e){ if(e.key==='Escape'){ close(); return; } if(e.key==='Tab') trap(e); }
  function trap(e){ var f=[].slice.call(root.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])')).filter(function(el){return el.offsetParent!==null;});
    if(!f.length) return; var first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); } }

  function busy(on){ root.classList.toggle('is-busy', !!on); }

  function refresh(){
    return fetch(window.location.pathname + '?sections=' + SECTION_ID)
      .then(function(r){ return r.json(); })
      .then(function(data){
        var doc = new DOMParser().parseFromString(data[SECTION_ID], 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var current = root.querySelector('[data-cart-contents]');
        if(fresh && current){
          current.innerHTML = fresh.innerHTML;
          var n = fresh.getAttribute('data-count');
          var packCount = fresh.getAttribute('data-pack-count');
          current.setAttribute('data-count', n);
          current.setAttribute('data-pack-count', packCount);
          root.querySelector('.cd__count').textContent = n;
          document.querySelectorAll('[data-cart-count],.cart-count,.cart-link__bubble,.header__cart-count').forEach(function(el){ el.textContent = n; });
          document.dispatchEvent(new CustomEvent('casa:cart:updated', { detail:{ count: parseInt(n,10) } }));
        }
      });
  }

  function change(key, qty){ busy(true);
    return fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ id:key, quantity:qty }) })
      .then(function(){ return refresh(); }).catch(function(){}).then(function(){ busy(false); }); }
  function add(id){ busy(true);
    return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ items:[{ id:id, quantity:1 }] }) })
      .then(function(){ return refresh(); }).catch(function(){}).then(function(){ busy(false); }); }

  root.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-close]')){ close(); return; }
    var li = e.target.closest('[data-line]');
    if(li){
      var key = li.getAttribute('data-line');
      var q = parseInt(li.querySelector('[data-qty-val]').textContent, 10) || 1;
      // Les remises packs sont natives Shopify (Réductions) : elles se recalculent
      // automatiquement selon la quantité réelle, pas besoin de logique custom ici.
      if(e.target.closest('[data-plus]')){ change(key, q+1); return; }
      if(e.target.closest('[data-minus]')){ change(key, Math.max(0, q-1)); return; }
      if(e.target.closest('[data-remove]')){ change(key, 0); return; }
    }
    var addBtn = e.target.closest('[data-add], [data-add-free]');
    if(addBtn){ add(addBtn.getAttribute('data-add') || addBtn.getAttribute('data-add-free')); return; }
  });
  overlay.addEventListener('click', close);

  // Ouverture : tout élément [data-cart-drawer-open]
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-cart-drawer-open]');
    if(t){ e.preventDefault(); open(); }
  });

  // Seuls les formulaires NON gérés par le composant natif <product-form> sont soumis ici
  // (celui-ci gère déjà sa propre requête cart/add.js -> éviter le double ajout).
  document.addEventListener('submit', function(e){
    var f = e.target.closest('form[action*="/cart/add"]');
    if(!f || f.closest('product-form')) return;
    e.preventDefault(); busy(true); open();
    fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body:new FormData(f) })
      .then(function(){ return refresh(); }).catch(function(){}).then(function(){ busy(false); });
  });

  // Les ajouts gérés nativement (fiche produit, quick-add collection, composeur duo PDP) déclenchent
  // divers événements panier -> on ouvre/rafraîchit le drawer casa en réaction, sans dupliquer l'ajout.
  function onExternalCartChange(){
    if(root.classList.contains('is-open')){ refresh(); } else { open(); }
  }
  document.documentElement.addEventListener('cart:change', onExternalCartChange);
  document.documentElement.addEventListener('theme:cart:change', onExternalCartChange);
  document.addEventListener('cart:refresh', onExternalCartChange);

  window.CasaCart = { open:open, close:close, refresh:refresh };
})();

  } catch(e) { console.error(e); }
})();
})();
